import { lazy } from "react";

export const importView = (name) => {
  return lazy(() =>
    import(
      /* webpackChunkName: "cust-[request]" */ `modules/cust/views/${name}`
    )
  );
};

export function getParentIds(arr, id) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].value === id) {
      return [id];
    } else if (arr[i].children && arr[i].children.length) {
      const t = getParentIds(arr[i].children, id);
      if (t !== false) {
        t.unshift(arr[i].value);
        return t;
      }
    }
  }

  return false;
}
